<template>
    <v-card light max-width="500">
        <v-card-text>
            <p class="bold body-25 text-center mb-0">Please enter your group number.</p>
            <p><small>(If you don't have a group number, one will be assigned to you).</small></p>
            <v-form ref="form" v-model="valid" id="form">
                <v-row wrap dense>
                    <v-col cols="12">
                        <v-text-field v-model="invite.FirstName" label="First Name" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="invite.LastName" label="Last Name" :rules="[rules.required]"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="invite.Email" label="Email" :rules="[rules.required, rules.email]"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="invite.Phone" label="Phone" :rules="[rules.required, rules.phone]"></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field v-model="invite.AccessCode" label="Group Number"
                            messages="Optional. If you don't have a group number, one will be assigned to you."
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-4">
                        <v-btn @click="submitAccessCode">Submit</v-btn>
                    </v-col>
                </v-row>
            </v-form>
            <v-progress-linear v-if="checking_access_code" indeterminate size="64"></v-progress-linear>
        </v-card-text>
        <v-alert color="red" top :timeout="6000" v-if="snackbar">
            {{ snackbar_text }}
            <v-btn text @click="snackbar = false">
                Close
            </v-btn>
        </v-alert>
    </v-card>
</template>
<script>
import Cookies from 'js-cookie'
import GlicAPI from './GlicAPI.js'
export default {
    data: function() {
        return {
            invite: {
                FirstName: null,
                LastName: null,
                Phone: null,
                Email: null,
                AccessCode: null
            },
            checking_access_code: false,
            snackbar: false,
            snackbar_text: null,
            rules: {
                'required': v => !!v || 'Required',
                'email': v => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                'zip': v => Number.isInteger(Number(v)) && Number(v) < 99999 && (v !== null && v.length == 5) || 'Enter a valid zipcode',
                'date': v => moment(v, 'MM-DD-YYYY').isValid() || 'Enter a valid birth date',
                'phone': v => (!!v && Number.isInteger(Number(v)) && v.length == 10) || 'Please enter a valid phone number in the phone field.',
            },
            valid: false,
        }
    },
    mounted: function() {

    },
    methods: {
        //emit's an update event so that the parent component can grab the name. 
        submitAccessCode: function() {
            if (this.$refs.form.validate() === false) {
                this.showAlert('Please fill out the required fields before continuing.')
                return
            }
            var g = this
            this.checking_access_code = true;
            g.snackbar = false;
            GlicAPI.submitAccessCode(this.invite).then(function(json) {
                g.checking_access_code = false
                if (json.message != null || json == null) {
                    g.snackbar_text = "Hmmm... that didn't seem to work. " + json.message
                    g.snackbar = true;
                    return;
                }
                Cookies.set("QuilityRxGroupCode", json.data.GroupCode, { expires: 365, sameSite : 'None', secure : true });
                Cookies.set("QuilityRxID", json.data.ID, { expires: 365, sameSite : 'None', secure : true });
                g.$nextTick(function() {
                    location.reload();
                })
            }).catch(function() {
                g.snackbar_text = "Hmmm... that didn't seem to work."
                g.snackbar = true;
                g.checking_access_code = false
            });
        }
    },
    watch: {
        'invite.Phone': function(newV, oldV) {
            var g = this;
            if (newV.length > 10) {
                this.$nextTick(function() { g.invite.Phone = g.invite.Phone.substring(0, 10) })
            }
            return

            if (oldV == null) {
                return
            }
            if (newV.length < oldV.length) {
                return;
            }
            if (newV.length == 3) {
                if (g.request.user.phone_number.indexOf("(") == 0) {
                    this.$nextTick(function() {
                        g.request.user.phone_number = g.request.user.phone_number.replace("(", "")
                    })
                    return
                }
                this.$nextTick(function() { g.request.user.phone_number = "(" + g.request.user.phone_number + ")" })
            }
            if (newV.length == 8) {
                this.$nextTick(function() { g.request.user.phone_number = g.request.user.phone_number + "-" })
            }
            if (newV.length > 13) {
                this.$nextTick(function() { g.request.user.phone_number = g.request.user.phone_number.substring(0, 13) })
            }
        },
    }
}
</script>